import type { SystemStyleObject } from '@chakra-ui/react';

export const sidebarCss: SystemStyleObject = {
  '&': {
    display: 'flex',
    flexDirection: 'column',
    gap: '76px',
    width: '286px',
    minWidth: '286px',
    paddingY: 4,
    paddingX: 8,
    bg: 'bg.panel',
  },

  '&[data-variant="aside"]': {
    display: { base: 'none', lg: 'flex' },
    position: 'sticky',
    top: 0,
    height: '100dvh',
    overflowY: 'auto',
    borderRightWidth: '1px',
    borderColor: 'border',
  },

  '&[data-variant="drawer"]': {
    width: 'full',
    minWidth: 0,
    gap: 10,
    paddingX: 4,
  },

  '& .logo-link': {
    display: 'inline-flex',
    alignSelf: 'flex-start',
    paddingTop: 1,
    borderRadius: 'l2',
    focusVisibleRing: 'outside',
  },

  '& .nav-groups': {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },

  '& .version': {
    marginTop: 'auto',
    fontSize: 'xs',
    color: 'fg.subtle',
  },
};

export const navGroupCss: SystemStyleObject = {
  '&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },

  '& .nav-group-label': {
    paddingY: 2,
    fontSize: 'xs',
    lineHeight: '1rem',
    fontWeight: 'bold',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'fg.subtle',
  },
};

export const navItemCss: SystemStyleObject = {
  '&': {
    display: 'flex',
    alignItems: 'center',
    gap: '17px',
    width: 'full',
    paddingY: '1.5',
    paddingX: 3,
    borderRadius: 'l3',
    color: 'fg.muted',
    textDecoration: 'none',
    transitionProperty: 'background',
    transitionDuration: 'fast',
    focusVisibleRing: 'outside',
  },

  '& .nav-icon': {
    flexShrink: 0,
    boxSize: 6,
    color: 'fg.muted',
    strokeWidth: 1.5,
  },

  '& .nav-text': {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },

  '& .nav-label': {
    fontSize: 'sm',
    lineHeight: '1.25rem',
    fontWeight: 'semibold',
  },

  '& .nav-description': {
    fontSize: 'xs',
    lineHeight: '1rem',
    fontWeight: 'normal',
    color: 'fg.subtle',
  },

  '&:is(a):hover': {
    bg: 'bg.muted',
    textDecoration: 'none',
  },

  '&[aria-current="page"]': {
    bg: 'bg.muted',
    color: 'fg',
  },

  '&[aria-current="page"] .nav-icon': {
    color: 'brand.solid',
  },

  '&[aria-disabled="true"]': {
    cursor: 'not-allowed',
  },
};
